// extracted by mini-css-extract-plugin
export default {"addClassContainer":"AddStudents_addClassContainer__hwnGJ","closeButton":"AddStudents_closeButton__5nYl9","fadeIn":"AddStudents_fadeIn__5tvXk","fadeOut":"AddStudents_fadeOut__ZiPx-"};